/* Matevara — price facet: keep the untouched price inputs out of the filter form.
 *
 * Ella's price-facet renders the min/max number inputs with a default value (0 and
 * the collection max) and a `name`, so they submit with EVERY filter form change —
 * which auto-appended a "$0 – max" price chip and price params to the URL even when
 * the user never touched price. We mark those default inputs `disabled` +
 * `data-fs-price-untouched` in Liquid; this script re-enables them the moment the
 * user actually interacts with the price control (slider or field), so real price
 * filtering still works. Runs on load and re-binds after Ella's AJAX re-renders. */
(function () {
  'use strict';

  function enablePriceBlock(block) {
    if (!block) return;
    // Restore the omitted `name` so this block's price inputs start serializing into
    // the filter form now that the user is actually setting a price range.
    var inputs = block.querySelectorAll('[data-fs-price-name]');
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].name = inputs[i].getAttribute('data-fs-price-name');
      inputs[i].removeAttribute('data-fs-price-name');
    }
  }

  function onPriceInteract(e) {
    var block = e.target.closest ? e.target.closest('price-range, .facets__priceblock, .facets-price') : null;
    if (block) enablePriceBlock(block);
  }

  function bind() {
    // Any pointer/keyboard interaction inside a price block re-enables its inputs.
    document.addEventListener('pointerdown', onPriceInteract, true);
    document.addEventListener('input', onPriceInteract, true);
    document.addEventListener('focusin', onPriceInteract, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
